import FinalCta from '@/components/FinalCta'
import FloatingWhatsApp from '@/components/FloatingWhatsApp'
import Footer from '@/components/Footer'
import Header from '@/components/Header'
import Hero from '@/components/Hero'
import HowItWorks from '@/components/HowItWorks'
import WhyChooseUs from '@/components/WhyChooseUs'

function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <Hero />
        <HowItWorks />
        <WhyChooseUs />
        <FinalCta />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  )
}

export default Home
